import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import {
  selectRegistrationCurrentStep,
  selectRegistrationInfo,
} from '../../../../../../store/selectors';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    header: PropTypes.string,
    main: PropTypes.string,
    actionsRow: PropTypes.string,
    inner: PropTypes.string,
  }).isRequired,
};

export const StepThree = props => {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <div className={classes.instruction}>
          Verify your email via the email sent to the address provided. <br />
          Check your junk/spam folder if you cannot see the activation email.
        </div>
      </div>
    </div>
  );
};

StepThree.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  currentStep: selectRegistrationCurrentStep(),
  registrationInfo: selectRegistrationInfo(),
});

export default withStyles(styles)(connect(mapStateToProps)(StepThree));
